import { useEffect, useRef } from 'react';
import Swal from 'sweetalert2';

interface AlertProps {
  type?: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message: string;
  isOpen: boolean;
  onClose: () => void;
  duration?: number;
}

const Alert: React.FC<AlertProps> = ({
  type = 'info',
  title,
  message,
  isOpen,
  onClose,
  duration = 5000,
}) => {
  // Keep the latest onClose without re-triggering the popup effect on every render.
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!isOpen) return;

    Swal.fire({
      icon: type,
      title,
      text: message,
      timer: duration,
      timerProgressBar: true,
      confirmButtonText: 'OK',
      confirmButtonColor: '#4f46e5',
    }).then(() => {
      onCloseRef.current();
    });
  }, [isOpen, type, title, message, duration]);

  // SweetAlert2 renders its own overlay outside React's tree; this component
  // itself has no visual output.
  return null;
};

export default Alert;
